import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const BackgroundImage = props => {

    const { alt, isDesktop, urlAssets } = props; 
    
    const backgroundImage = isDesktop ? 'desktop.png' : 'mobile.jpg';

    return (
        <article className="position-fixed start-50 translate-middle-x w-100 text-center">
            <LazyLoadImage
                alt={alt}
                className="img-fluid"
                effect="blur"
                src={`${urlAssets}/img/background-${backgroundImage}`}
            />
        </article>
    )
}

export default BackgroundImage

BackgroundImage.propTypes = {
    alt: PropTypes.string.isRequired,
    isDesktop: PropTypes.bool.isRequired,
    urlAssets: PropTypes.string.isRequired
}
